import { render, staticRenderFns } from "./CookiesPrivacy.vue?vue&type=template&id=0268f3b6&scoped=true&"
import script from "./CookiesPrivacy.vue?vue&type=script&lang=js&"
export * from "./CookiesPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0268f3b6",
  null
  
)

export default component.exports